import { generateMessageDisplayedSegment, generateServerResponseError, track } from 'utils/segmenTracker';
import { gtAPI, svAPI } from '../../constants/api';
import fetchApi from '../../services/fetch';
import { ACTIVATION, MESSAGE_DISPLAYED, SERVER_RESPONSE_FAILED } from 'constants/segmentEvents';


const initialState = {
  data: {
    error: false
  },
  location: [],
  coverage: {},
  suburb: [],
  mapConfig: {},
  permissionError: false,
  nodeFound: null,
  checkCoverageButtonDisabled: true
}

export const location = {
  state: { ...initialState },
  reducers: {
    updateLocationError(state, payload) {
      return {
        ...state,
        data: { ...state.data, error: payload }
      }
    },
    clearLocationError() {
      return {
        ...initialState
      }
    },
    updateLocation(state, payload) {
      return {
        ...state,
        location: payload
      };
    },
    updateButtonDisabled(state, payload) {
      return {
        ...state,
        checkCoverageButtonDisabled: payload
      };
    },
    updateMapConfig(state, payload) {
      return {
        ...state,
        mapConfig: { ...state.mapConfig, ...payload }
      };
    },
    updateCoverage(state, payload) {
      return {
        ...state,
        coverage: { ...state.coverage, ...payload }
      };
    },
    clearLocation() {
      return {
        ...initialState,
      }
    },
    resetCoverage(state) {
      return {
        ...state,
        coverage: { ...initialState.coverage }
      };
    },
    setPermissionStatus(state, payload) {
      return {
        ...state,
        permissionError: payload
      }
    },
    setNodeFound(state, payload) {
      return {
        ...state,
        nodeFound: payload
      }
    }
  },
  effects: (dispatch) => {
    return {
      async checkCoverage(data) {
        dispatch.apiStatus.setProcessing(true);
        fetchApi({
          method: 'get',
          url: `${svAPI.checkCoverage}?latitude=${data[0]}&longitude=${data[1]}`,
        })
          .then(response => {

            const { data } = response;
            const coverageInfo = [
              {
                id: data?.node,
                category: data?.nodeClass,
                doubleWay: ""
              }
            ]

            dispatch.location.updateCoverage(response.data);
            dispatch.inputAddress.updateCoverageInfo(coverageInfo);
            dispatch.inputAddress.updateCoverageNode(response.data?.node);
            dispatch.location.setNodeFound(true);
            dispatch.apiStatus.setProcessing(false);

          })
          .catch(error => {
            // if (error.errorCode !== 404) {
            //   if (typeof error.message === 'object') {
            //     dispatch.apiStatus.setRequestFailed({
            //       errorCode: error.errorCode,
            //       message: error.message.message,
            //     });
            //   } else {
            //     dispatch.apiStatus.setRequestFailed({ ...error });
            //   }
            // }
            // else {
            //   dispatch.apiStatus.setProcessing(false);
            // }
            dispatch.apiStatus.setProcessing(false);
            dispatch.location.setNodeFound(false);


            track(SERVER_RESPONSE_FAILED, { ...generateServerResponseError(error, ACTIVATION, 'Input Address', svAPI.checkCoverage, 'Coverage API') })
            track(MESSAGE_DISPLAYED, { ...generateMessageDisplayedSegment(error, ACTIVATION, 'Coverage API') })
          });
      },
    }
  }
}